import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import CTASection from "../sections/CTASection";
import { NEWS } from "../data/content";

export default function Article() {
  const { slug } = useParams();
  const article = NEWS.find((n) => n.slug === slug);

  useSEO({
    title: article ? article.title : "News",
    description: article ? article.excerpt : "",
  });

  if (!article) return <Navigate to="/news" replace />;

  return (
    <>
      <PageHero
        overline={`News · ${article.date}`}
        title={article.title}
        image={article.heroImage || article.image}
      />

      <article className="section-y">
        <div className="container-x max-w-3xl">
          <Reveal>
            <Link
              to="/news"
              data-testid="article-back"
              className="mb-12 inline-flex items-center gap-2 text-sm text-neutral-400 transition-colors hover:text-gold"
            >
              <ArrowLeft size={16} /> Back to News
            </Link>
          </Reveal>

          <Reveal>
            <div className="relative mb-14 overflow-hidden rounded-3xl border border-white/5">
              <img src={article.image} alt={article.title} className="w-full object-cover" />
            </div>
          </Reveal>

          <div className="space-y-6">
            {article.body.map((block, i) =>
              block.type === "h2" ? (
                <Reveal key={i}>
                  <h2 className="pt-6 font-playfair text-2xl text-white sm:text-3xl">
                    {block.text}
                  </h2>
                </Reveal>
              ) : block.type === "img" ? (
                <Reveal key={i}>
                  <figure className="py-4">
                    <div className="overflow-hidden rounded-2xl border border-white/5">
                      <img
                        src={block.src}
                        alt={block.caption || article.title}
                        loading="lazy"
                        className="w-full object-cover"
                      />
                    </div>
                    {block.caption && (
                      <figcaption className="mt-3 text-center text-xs uppercase tracking-[0.15em] text-neutral-500">
                        {block.caption}
                      </figcaption>
                    )}
                  </figure>
                </Reveal>
              ) : (
                <Reveal key={i}>
                  <p className="text-base font-light leading-relaxed text-neutral-300">
                    {block.text}
                  </p>
                </Reveal>
              )
            )}
          </div>
        </div>
      </article>

      <CTASection />
    </>
  );
}
